import { render, staticRenderFns } from "./ClinicPortal.vue?vue&type=template&id=1a0b001c&scoped=true"
import script from "./ClinicPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicPortal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClinicPortal.vue?vue&type=style&index=0&id=1a0b001c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b001c",
  null
  
)

export default component.exports